import { render, staticRenderFns } from "./VersionManagement.vue?vue&type=template&id=7f6bb73e&scoped=true"
import script from "./VersionManagement.vue?vue&type=script&lang=js"
export * from "./VersionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6bb73e",
  null
  
)

export default component.exports